import http from '../utils/http'
import qs from 'qs'; // 根据需求是否导入qs模块
/**
 *  @parms resquest 请求地址 例如：http://10.0.0.99:8080/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/ustayz/"
let api = "/api/"

// 所有请求(包含POST/GET/DELETE/PUT等)
export default{
  // 登录接口
  login(params) {
    return http.post(`${resquest}g_admin/login`, qs.stringify(params));
  },
  // 修改密码
  saveOrUpdateLogin(params) {
    return http.post(`${resquest}admin/saveOrUpdate`, qs.stringify(params));
  },
  // 房源-排序
  sortHouse(params) {
    return http.post(`${resquest}house/sort`, qs.stringify(params));
  },
  // 房源-搜索
  findHouse(params) {
    return http.post(`${resquest}house/find`, qs.stringify(params));
  },
  // 房源-搜索
  searchHouse(params) {
    return http.post(`${resquest}house/search`, qs.stringify(params));
  },
  // 房源-新增编辑
  saveOrUpdateHouse(params) {
    return http.post(`${resquest}house/saveOrUpdate`, qs.stringify(params));
  },
  // 房源-新增编辑批量
  saveOrUpdateHouseBatch(params) {
    return http.post(`${resquest}house/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 房源-申请房源流水号
  houseApplyNo(params) {
    return http.post(`${resquest}house/applyNo`, qs.stringify(params));
  },
  // 房源-查找Id
  findHouseById(params) {
    return http.post(`${resquest}house/getById`, qs.stringify(params));
  },
  // 房源-复制
  houseCopy(params) {
    return http.post(`${resquest}house/copy`, qs.stringify(params));
  },
  // 房源-删除
  houseDelete(params) {
    return http.post(`${resquest}house/delete`, qs.stringify(params));
  },
  // 房源-删除
  houseDeleteBatch(params) {
    return http.post(`${resquest}house/deleteBatch`, qs.stringify(params));
  },
  // 房型-查找
  findApartmentClassify(params) {
    return http.post(`${resquest}apartment_classify/find`, qs.stringify(params));
  },
  // 房型-新增编辑
  saveOrUpdateApartmentClassify(params) {
    return http.post(`${resquest}apartment_classify/saveOrUpdate`, qs.stringify(params));
  },
  // 房型-新增编辑
  saveOrUpdateApartmentClassifyBatch(params) {
    return http.post(`${resquest}apartment_classify/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 管理员-查找
  findAdmin(params) {
    return http.post(`${resquest}admin/find`, qs.stringify(params));
  },
  // 管理员-新增编辑
  saveOrUpdateAdmin(params) {
    return http.post(`${resquest}admin/saveOrUpdate`, qs.stringify(params));
  },
  // 管理员-新增编辑批量
  saveOrUpdateAdminBatch(params) {
    return http.post(`${resquest}admin/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 用户-查找
  findMember(params) {
    return http.post(`${resquest}member/find`, qs.stringify(params));
  },
  // 用户-根据Id查找
  findMemberById(params) {
    return http.post(`${resquest}member/getById`, qs.stringify(params));
  },
  // 平台优惠管理-查找
  findPreferential(params) {
    return http.post(`${resquest}preferential/find`, qs.stringify(params));
  },
  // 平台优惠管理-新增编辑
  saveOrUpdatePreferential(params) {
    return http.post(`${resquest}preferential/saveOrUpdate`, qs.stringify(params));
  },
  // 平台优惠管理-新增编辑批量
  saveOrUpdatePreferentialBatch(params) {
    return http.post(`${resquest}preferential/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 咨询-查找
  findMessage(params) {
    return http.post(`${resquest}message/find`, qs.stringify(params));
  },
  // 房源排序管理-添加到排序管理
  houseAddTopping(params) {
    return http.post(`${resquest}house/addTopping`, qs.stringify(params));
  },
  // 房源排序管理-删除到排序管理
  houseDeleteTopping(params) {
    return http.post(`${resquest}house/deleteTopping`, qs.stringify(params));
  },
  // 房源排序管理-调整排序管理的排序
  houseUpdataTopping(params) {
    return http.post(`${resquest}house/updataTopping`, qs.stringify(params));
  },
  // 房源排序管理-获取排序管理的排序
  houseSearchTopping(params) {
    return http.post(`${resquest}house/searchTopping`, qs.stringify(params));
  },
  // 房源排序管理-获取未添加排序管理的排序
  houseSearchUnTopping(params) {
    return http.post(`${resquest}house/unTopping`, qs.stringify(params));
  },
  // 咨询-编辑
  saveOrUpdateMessage(params) {
    return http.post(`${resquest}message/saveOrUpdate`, qs.stringify(params));
  },
  // 咨询-查找
  searchMessage(params) {
    return http.post(`${resquest}message/search`, qs.stringify(params));
  },
  // 城市-查找
  findCity(params) {
    return http.post(`${resquest}city/find`, qs.stringify(params));
  },
  // 城市-新增编辑
  saveOrUpdateCity(params) {
    return http.post(`${resquest}city/saveOrUpdate`, qs.stringify(params));
  },
  // 城市-新增编辑批量
  saveOrUpdateCityBatch(params) {
    return http.post(`${resquest}city/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 卖点标签-查找
  findTag(params) {
    return http.post(`${resquest}tag/find`, qs.stringify(params));
  },
  // 卖点标签-新增编辑
  saveOrUpdateTag(params) {
    return http.post(`${resquest}tag/saveOrUpdate`, qs.stringify(params));
  },
  // 卖点标签-新增编辑批量
  saveOrUpdateTagBatch(params) {
    return http.post(`${resquest}tag/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 房源卖点标签-查找
  findTagHouse(params) {
    return http.post(`${resquest}tag_house/find`, qs.stringify(params));
  },
  // 房源卖点标签-查找
  getTagHouseByHouseId(params) {
    return http.post(`${resquest}house/getTagHouseByHouseId`, qs.stringify(params));
  },
  // 房源卖点标签-新增编辑
  saveOrUpdateTagHouse(params) {
    return http.post(`${resquest}tag_house/saveOrUpdate`, qs.stringify(params));
  },
  // 房源卖点标签-新增编辑
  saveOrUpdateTagAssistantBatch(params) {
    return http.post(`${resquest}assistant/saveOrUpdateTagBatch`, qs.stringify(params));
  },
  // 房源卖点标签-新增编辑批量
  saveOrUpdateTagHouseBatch(params) {
    return http.post(`${resquest}tag_house/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 只适合保存学生公寓下的户型房源
  saveOrUpdateHouseTypeOfApartmentHouse(params) {
    return http.post(`${resquest}house/saveOrUpdateHouseTypeOfApartment`, qs.stringify(params));
  },
  // 只适合保存学生公寓下的户型房源
  getChildrenOfApartment(params) {
    return http.post(`${resquest}house/childrenOfApartment`, qs.stringify(params));
  },
  // 学校-查找
  findSchool(params) {
    return http.post(`${resquest}school/find`, qs.stringify(params));
  },
  // 学校-新增编辑
  saveOrUpdateSchool(params) {
    return http.post(`${resquest}school/saveOrUpdate`, qs.stringify(params));
  },
  // 学校-新增编辑批量
  saveOrUpdateSchoolBatch(params) {
    return http.post(`${resquest}school/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 费用-查找
  findCost(params) {
    return http.post(`${resquest}cost/find`, qs.stringify(params));
  },
  // 费用-新增编辑
  saveOrUpdateCost(params) {
    return http.post(`${resquest}cost/saveOrUpdate`, qs.stringify(params));
  },
  // 费用-新增编辑批量
  saveOrUpdateCostBatch(params) {
    return http.post(`${resquest}cost/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 费用明细-查找
  findCostHouse(params) {
    return http.post(`${resquest}cost_house/find`, qs.stringify(params));
  },
  // 费用明细-查找
  getCostHouseByHouseId(params) {
    return http.post(`${resquest}house/getCostHouseByHouseId`, qs.stringify(params));
  },
  // 费用明细-新增编辑
  saveOrUpdateCostHouse(params) {
    return http.post(`${resquest}cost_house/saveOrUpdate`, qs.stringify(params));
  },
  // 费用明细-新增编辑批量
  saveOrUpdateCostHouseBatch(params) {
    return http.post(`${resquest}cost_house/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 费用明细-新增编辑批量
  saveOrUpdateCostAssistantBatch(params) {
    return http.post(`${resquest}assistant/saveOrUpdateCostBatch`, qs.stringify(params));
  },
  // 到校方式-查找
  getHouseWay(params) {
    return http.post(`${resquest}house/getWay`, qs.stringify(params));
  },
  // 到校方式-新增编辑
  saveOrUpdateWay(params) {
    return http.post(`${resquest}way/saveOrUpdate`, qs.stringify(params));
  },
  // 到校方式-新增编辑批量
  saveOrUpdateWayBatch(params) {
    return http.post(`${resquest}way/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 到校方式-新增编辑批量
  saveOrUpdateSchoolAssistantBatch(params) {
    return http.post(`${resquest}assistant/saveOrUpdateSchoolBatch`, qs.stringify(params));
  },
  // 公共交通距离和时间-查找
  getHouseTransit(params) {
    return http.post(`${resquest}house/getTransit`, qs.stringify(params));
  },
  // 公共交通距离-新增编辑
  saveOrUpdateTransit(params) {
    return http.post(`${resquest}transit/saveOrUpdate`, qs.stringify(params));
  },
  // 公共交通距离-新增编辑批量
  saveOrUpdateTransitBatch(params) {
    return http.post(`${resquest}transit/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 床垫-查找
  findMattress(params) {
    return http.post(`${resquest}mattress/find`, qs.stringify(params));
  },
  // 床垫-新增编辑
  saveOrUpdateMattress(params) {
    return http.post(`${resquest}mattress/saveOrUpdate`, qs.stringify(params));
  },
  // 床垫-新增编辑批量
  saveOrUpdateMattressBatch(params) {
    return http.post(`${resquest}mattress/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 区域-查找
  findRegion(params) {
    return http.post(`${resquest}region/find`, qs.stringify(params));
  },
  // 区域-新增编辑
  saveOrUpdateRegion(params) {
    return http.post(`${resquest}region/saveOrUpdate`, qs.stringify(params));
  },
  // 区域-新增编辑批量
  saveOrUpdateRegionBatch(params) {
    return http.post(`${resquest}region/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 房屋信息管理-查找
  findCustom(params) {
    return http.post(`${resquest}custom/find`, qs.stringify(params));
  },
  // 房屋信息管理-查找
  getCustomHouseByHouseId(params) {
    return http.post(`${resquest}house/getCustomHouseByHouseId`, qs.stringify(params));
  },
  // 房屋信息管理-新增编辑
  saveOrUpdateCustom(params) {
    return http.post(`${resquest}custom/saveOrUpdate`, qs.stringify(params));
  },
  // 房屋信息管理-新增编辑批量
  saveOrUpdateCustomBatch(params) {
    return http.post(`${resquest}custom/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 房屋信息管理-新增编辑批量
  saveOrUpdateCustomAssistantBatch(params) {
    return http.post(`${resquest}assistant/saveOrUpdateCustomBatch`, qs.stringify(params));
  },
  // 房源房屋信息管理-查找
  findCustomHouse(params) {
    return http.post(`${resquest}custom_house/find`, qs.stringify(params));
  },
  // 房源房屋信息管理-新增编辑
  saveOrUpdateCustomHouse(params) {
    return http.post(`${resquest}custom_house/saveOrUpdate`, qs.stringify(params));
  },
  // 房源房屋信息管理-新增编辑批量
  saveOrUpdateCustomHouseBatch(params) {
    return http.post(`${resquest}custom_house/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 价格-查找
  findPrice(params) {
    return http.post(`${resquest}price/find`, qs.stringify(params));
  },
  // 价格-新增编辑
  saveOrUpdatePrice(params) {
    return http.post(`${resquest}price/saveOrUpdate`, qs.stringify(params));
  },
  // 价格-新增编辑批量
  saveOrUpdatePriceBatch(params) {
    return http.post(`${resquest}price/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 地标-查找
  findLandmark(params) {
    return http.post(`${resquest}landmark/find`, qs.stringify(params));
  },
  // 地标-新增编辑
  saveOrUpdateLandmark(params) {
    return http.post(`${resquest}landmark/saveOrUpdate`, qs.stringify(params));
  },
  // 地标-新增编辑批量
  saveOrUpdateLandmarkBatch(params) {
    return http.post(`${resquest}landmark/saveOrUpdateBatch`, qs.stringify(params));
  },
  // banner-查找
  findBanner(params) {
    return http.post(`${resquest}banner/find`, qs.stringify(params));
  },
  // banner-新增编辑
  saveOrUpdateBanner(params) {
    return http.post(`${resquest}banner/saveOrUpdate`, qs.stringify(params));
  },
  // banner-新增编辑批量
  saveOrUpdateBannerBatch(params) {
    return http.post(`${resquest}banner/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 安家服务-查找
  findSettleDown(params) {
    return http.post(`${resquest}settle_down/find`, qs.stringify(params));
  },
  // 安家服务-新增编辑
  saveOrUpdateSettleDown(params) {
    return http.post(`${resquest}settle_down/saveOrUpdate`, qs.stringify(params));
  },
  // 安家服务-新增编辑批量
  saveOrUpdateSettleDownBatch(params) {
    return http.post(`${resquest}settle_down/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 客服二维码-查找
  findAdviserQr(params) {
    return http.post(`${resquest}adviserqr/find`, qs.stringify(params));
  },
  // 客服二维码-新增编辑
  saveOrUpdateAdviserQr(params) {
    return http.post(`${resquest}adviserqr/saveOrUpdate`, qs.stringify(params));
  },
  // 服务设施-查找
  findFacilities(params) {
    return http.post(`${resquest}facilities/find`, qs.stringify(params));
  },
  // 服务设施-新增
  saveOrUpdateFacilities(params) {
    return http.post(`${resquest}facilities/saveOrUpdate`, qs.stringify(params));
  },
  // 服务设施-编辑
  houseEditFacilities(params) {
    return http.post(`${resquest}house/editFacilities`, qs.stringify(params));
  },
  // 服务设施-新增编辑批量
  saveOrUpdateFacilitiesBatch(params) {
    return http.post(`${resquest}facilities/saveOrUpdateBatch`, qs.stringify(params));
  },
  // 服务设施-批量删除设施
  deleteHouseFacilities(params) {
    return http.post(`${resquest}house/deleteFacilities`, qs.stringify(params));
  },
  // 上传图片文件
  fileUpload(params) {
    return http.postUpload(`${api}file/upload`,params);
  },
}



// WEBPACK FOOTER //
// ./src/api/api.js